import { ExamCenterProctorRequestType } from '@exam-center/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  parseAsArrayOf,
  useQueryStates,
} from 'nuqs';
const PROCTOR_REQUEST_STATUSES = ['IN_REVIEW', 'REJECTED'] as const;
export type AdminProctorRequestStatus = (typeof PROCTOR_REQUEST_STATUSES)[number];
type SortOrder = (typeof dataGridSortDirection)[number];

export default function useAdminProctorRequestListSearchParams() {
  const [
    { status, page, pageSize, sortOrder, sortBy, search, proctorType, examCenter },
    setAdminProctorRequestListSearchParams,
  ] = useQueryStates({
    status: parseAsStringLiteral(PROCTOR_REQUEST_STATUSES).withDefault('IN_REVIEW'),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString,
    search: parseAsString.withDefault(''),
    proctorType: parseAsArrayOf(
      parseAsStringLiteral(Object.values(ExamCenterProctorRequestType)),
    ).withDefault([]),
    examCenter: parseAsArrayOf(parseAsString).withDefault([]),
  });

  const changePageNumber = (page: number) => {
    setAdminProctorRequestListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setAdminProctorRequestListSearchParams({ pageSize, page: 0 });
  };

  const changeStatus = (status: AdminProctorRequestStatus) => {
    setAdminProctorRequestListSearchParams({ status, page: 0, pageSize: 10 });
  };

  const changeSearch = (value: string) => {
    setAdminProctorRequestListSearchParams({ search: value, page: 0 });
  };
  const changeProctorType = (proctorType: ExamCenterProctorRequestType[]) => {
    setAdminProctorRequestListSearchParams({ proctorType, page: 0 });
  };
  const changeExamCenter = (examCenter: string[]) => {
    setAdminProctorRequestListSearchParams({ examCenter, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setAdminProctorRequestListSearchParams({ sortOrder, page: 0, sortBy });
  };

  return [
    { status, page, pageSize, sortOrder, sortBy, search, proctorType, examCenter },
    {
      changeStatus,
      changePageNumber,
      changePageSize,
      changeSorting,
      changeSearch,
      changeProctorType,
      changeExamCenter,
    },
  ] as const;
}
